import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.function.name.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/createTree.ts";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.join.js";
import { getChildren, getNode } from "../../classifier-service";
import { isBimNode, isReferenceNode, isUserClassifierGroupNode } from "../../classifier-service/Node";
import { groupSort } from "../NodeSort/groupSort";
import { buildTreeItemKey } from "./buildTreeItemKey";
var limitChildren = 40;
export var isApiFlatNode = function isApiFlatNode(node) {
  return !(node.ref.type === 'LoadMore' || node.ref.type === 'CreateNode');
};
export function createGroupNodeKey(_ref) {
  var id = _ref.id;
  return "UserClassifierGroup_".concat(id);
}
export function createReferenceNodeKey(_ref2) {
  var id = _ref2.id;
  return "Reference_".concat(id);
}
export function createBimNodeKey(_ref3) {
  var id = _ref3.id,
      parentRefId = _ref3.parentRefId,
      type = _ref3.type;
  return "".concat(parentRefId, "_").concat(type, "_").concat(id);
}
export function createChildTree(_ref4) {
  var nodes = _ref4.nodes,
      rootNodeRefs = _ref4.rootNodeRefs,
      inCreateNode = _ref4.inCreateNode,
      dynamicMode = _ref4.dynamicMode,
      treeOrderMap = _ref4.treeOrderMap;
  var result = [];

  function recursive(_ref5) {
    var nodeRef = _ref5.nodeRef,
        path = _ref5.path,
        parentRefId = _ref5.parentRefId;
    var node = getNode(nodes, nodeRef);

    if (!node) {
      console.error('not found node', nodeRef, nodes);
      throw new Error('not found node'); // TODO
    } // Ссылка на ноду без лишних свойств


    var trueNodeRef = {
      type: node.type,
      id: node.id
    };
    var nextPath = [].concat(_toConsumableArray(path), [buildTreeItemKey(node)]);
    result.push({
      path: nextPath,
      ref: trueNodeRef
    });
    var nodeForChildren = isReferenceNode(node) ? getNode(nodes, node.element) : node;
    var nextParentRefId = isReferenceNode(node) ? node.id : parentRefId;

    if (nodeForChildren && 'children' in nodeForChildren) {
      var total = nodeForChildren.total;
      var children = groupSort(getChildren(nodes, nodeForChildren), nodes);

      if (dynamicMode && isUserClassifierGroupNode(nodeForChildren) && nodeForChildren.dynamicGroup) {
        var n = getNode(nodes, nodeForChildren.dynamicGroup);

        if (n && 'children' in n) {
          children = groupSort(getChildren(nodes, n), nodes);
          total = n.total;
        }
      }

      children.slice().sort(function (a, b) {
        var aOrder = getPriorityOrder(a, nodes, treeOrderMap, nextParentRefId);
        var bOrder = getPriorityOrder(b, nodes, treeOrderMap, nextParentRefId);
        return aOrder - bOrder;
      }).forEach(function (ch) {
        return recursive({
          nodeRef: ch,
          path: nextPath,
          parentRefId: nextParentRefId
        });
      }); // Пагинация

      if (children.length && total > limitChildren && total - children.length > 0) {
        result.push({
          path: [].concat(_toConsumableArray(nextPath), ['LoadMore']),
          ref: {
            type: 'LoadMore',
            parentNodeRef: trueNodeRef
          }
        });
      }
    } // Форма создания вложенной ноды


    if (inCreateNode !== null && inCreateNode !== void 0 && inCreateNode.parentNodeRef) {
      var _inCreateNode$parentN = inCreateNode.parentNodeRef,
          id = _inCreateNode$parentN.id,
          type = _inCreateNode$parentN.type;

      if (id === nodeRef.id && type === nodeRef.type) {
        result.push(createNode({
          parentNodeRef: nodeRef,
          createType: 'Input',
          nextPath: nextPath
        }));
      }
    }
  }

  rootNodeRefs.slice().sort(function (a, b) {
    var aOrder = getPriorityOrder(a, nodes, treeOrderMap, null);
    var bOrder = getPriorityOrder(b, nodes, treeOrderMap, null);
    return aOrder - bOrder;
  }).forEach(function (r) {
    return recursive({
      nodeRef: r,
      path: [],
      parentRefId: null
    });
  }); // Форма создания рутовой ноды

  if (inCreateNode && !inCreateNode.parentNodeRef) {
    result.push(createNode({
      parentNodeRef: null,
      createType: 'Input'
    }));
  }

  result.push(createNode({
    parentNodeRef: null,
    createType: 'Field'
  }));
  return result;
}

function getPriorityOrder(nodeRef, nodes, priorityOrderMap, parentRefId) {
  var node = getNode(nodes, nodeRef);

  if (!node) {
    return 0;
  }

  var key = '';

  if (isUserClassifierGroupNode(node)) {
    key = createGroupNodeKey({
      id: node.id
    });
  } else if (isBimNode(node)) {
    key = createBimNodeKey({
      id: node.id,
      parentRefId: parentRefId,
      type: node.type
    });
  } else if (isReferenceNode(node)) {
    key = createReferenceNodeKey({
      id: node.id
    });
  }

  return priorityOrderMap[key] || 0;
}

export function filterNotExpandedTree(_ref6) {
  var expanded = _ref6.expanded,
      tree = _ref6.tree;
  var result = [];
  tree.forEach(function (item) {
    var parentPath = item.path.slice(0, -1);
    var everyParentExpanded = item.path.every(function (k, idx) {
      return expanded[parentPath.slice(0, idx + 1).join(':')];
    });

    if (item.path.length <= 1 || everyParentExpanded) {
      result.push(item);
    }
  });
  return result;
}

var createNode = function createNode(_ref7) {
  var parentNodeRef = _ref7.parentNodeRef,
      nextPath = _ref7.nextPath,
      createType = _ref7.createType;
  return {
    path: nextPath ? [].concat(_toConsumableArray(nextPath), ['CreateNode']) : ['CreateNode'],
    ref: {
      type: 'CreateNode',
      createType: createType,
      parentNodeRef: parentNodeRef
    }
  };
};